export default "/assets/website/images/logo_icon.svg?bc64b0925c2818eb5c41ede2e7847f01";